import { ProtectedJsonAPI } from './ProtectedJsonAPI'

export const Rcpd = ProtectedJsonAPI.extend(
  '/rcpd',
  {
    peaks:   endpoint => endpoint.path('peaks'),
    loads:   endpoint => endpoint.path('loads')
  }
)